import { useEffect, useState } from "react";
import { services } from "./utils";
import { readDataStorage } from "../../utils/storage/storage";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";

// ----------------------------------------------------------------------

export default function NotificationsModal() {
  const { CpfRepresentante } = readDataStorage("login");

  // ----------------------------------------------------------------------

  const [showModal, setShowModal] = useState(false);

  const getData = async () => {
    try {
      const runned = localStorage.getItem("@ARP:notifications-after-login");
      console.log(runned);
      if (runned === "true") return;
      const notifications = await services.listNotifications(CpfRepresentante);
      const unread = notifications.filter((item) => !item.read);
      if (unread.length) setShowModal(true);
      localStorage.setItem("@ARP:notifications-after-login", "true");
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ----------------------------------------------------------------------

  const openNotifications = () => {
    setShowModal(false);
    window.open("/arp/notifications", "_blank")?.focus();
  };

  const closeModal = () => {
    setShowModal(false);
  };

  // ----------------------------------------------------------------------

  return (
    <Dialog open={showModal} fullWidth maxWidth="xs">
      <DialogTitle sx={{ fontWeight: 700, textAlign: "center" }}>
        Você possui notificações não lidas
      </DialogTitle>

      <DialogContent sx={{ paddingBottom: 2 }}></DialogContent>

      <DialogActions
        sx={{
          p: 2.5,
          pt: 0,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Button
          variant="outlined"
          onClick={closeModal}
          sx={{
            color: "#6c5af4",
            borderColor: "#6c5af4",
            "&:hover": {
              borderColor: "#6c5af4",
              backgroundColor: "#6c5af41A",
            },
            textTransform: "none",
            fontSize: 16,
            borderRadius: 2,
          }}
        >
          Fechar aviso
        </Button>

        <Button
          variant="contained"
          onClick={openNotifications}
          sx={{
            backgroundColor: "#6c5af4",
            "&:hover": { backgroundColor: "#6c5af4DD" },
            textTransform: "none",
            fontSize: 16,
            borderRadius: 2,
          }}
        >
          Ler notificações agora
        </Button>
      </DialogActions>
    </Dialog>
  );
}
